import { App, type AppState } from "@capacitor/app";
import { useEffect, useState } from "react";

export const useAppState = () => {
  const [appState, setAppState] = useState<AppState | null>();

  useEffect(() => {
    App.getState().then(setAppState);

    const promise = App.addListener("appStateChange", setAppState);

    return () => {
      promise.then((listener) => listener.remove());
    };
  }, []);

  return appState;
};
